import type { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';
import { EMPTY } from 'rxjs';

export interface SentryCurrentAdmin {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  roleName?: string;
}

export interface SentryCurrentCompany {
  id?: number;
}

export abstract class AccountBase {
  public currentAdmin$: Observable<SentryCurrentAdmin> = EMPTY;
  public currentCompany$: Observable<SentryCurrentCompany | null> = EMPTY;
}

export class SentryConfig {
  public enable: boolean;
  public dsn: string;
  public revisionToken: InjectionToken<string>;
  public environmentName?: string;
}
